module.exports = __webpack_public_path__ + "img/kairan.e0624e01.jpg";